import styled, {css} from 'styled-components';

import {mixins} from '@edna/components/styles';

import {Link as BaseLink} from 'src/components/primitives';

export const Footer = styled.footer`
  ${mixins.flexAlign('space-between', 'center')}
  width: 100%;
  min-height: 40px;
  ${({theme: {spacing, branding}}) => css`
    padding: ${spacing.s4} ${spacing.s3};
    background-color: ${branding.content.primary};

    ${mixins.media.laptop`
      padding: 0 0 0 calc(100vw - 100%);
    `}
  `};
`;

export const FooterContent = styled.div`
  ${mixins.flexAlign('space-between', 'center')}
  ${mixins.wh('100%')}
  ${mixins.f3}
  max-width: 940px;
  height: 100%;
  margin: 0 auto;
`;

export const Link = styled(BaseLink)`
  ${mixins.f2}

  ${({theme}) => css`
    color: ${theme.palette.grey300};
    margin-right: ${theme.spacing.s3};
  `};

  ${mixins.media.laptop`
    ${mixins.f3}
  `}
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;

  ${mixins.media.laptop`
    flex-direction: row;
  `}
`;

export const CopyRight = styled.span`
  margin-right: 10px;
  color: ${({theme}) => theme.branding.content.tertiary};
`;
